<template>
  <v-dialog :model-value="dialog" @update:model-value="updateDialog" max-width="500px">
    <v-card>
      <v-card-title>Editar Matrícula</v-card-title>
      <v-card-text>
        <v-text-field v-model="localMatricula.fecha" label="Fecha" type="date" />
        <v-text-field v-model.number="localMatricula.costo" label="Costo" type="number" prefix="S/ " />
        <v-select
          v-model="localMatricula.medio_contacto_id"
          :items="mediosContacto"
          item-title="descripcion"
          item-value="id"
          label="Medio de contacto"
          clearable
        />
        <v-switch v-model="localMatricula.visa" label="Pago con POS" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn color="primary" text @click="save" :disabled="!localMatricula.id">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    dialog: Boolean,
    editedItem: { type: Object, default: () => ({}) },
    alumnoId: [String, Number],
  },
  emits: ['update:dialog', 'matricula-actualizada'],
  data() {
    return {
      mediosContacto: [],
      localMatricula: {
        id: null,
        fecha: '',
        costo: 0,
        visa: false,
        medio_contacto_id: null,
        ...this.editedItem,
      },
    };
  },
  watch: {
    editedItem: {
      handler(v) {
        this.localMatricula = {
          id: null,
          fecha: '',
          costo: 0,
          visa: false,
          medio_contacto_id: null,
          ...v,
        };
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.loadMediosContacto();
  },
  methods: {
    ...mapActions('alumno', ['updateMatricula', 'fetchMediosContacto']),
    async loadMediosContacto() {
      try {
        const data = await this.fetchMediosContacto();
        this.mediosContacto = Array.isArray(data) ? data : data?.data ?? [];
      } catch (e) {
        this.mediosContacto = [];
      }
    },
    updateDialog(v) {
      this.$emit('update:dialog', v);
    },
    close() {
      this.updateDialog(false);
    },
    async save() {
      try {
        await this.updateMatricula({
          alumnoId: this.alumnoId,
          matriculaId: this.localMatricula.id,
          fecha: this.localMatricula.fecha,
          costo: this.localMatricula.costo,
          visa: this.localMatricula.visa,
          medio_contacto_id: this.localMatricula.medio_contacto_id,
        });
        this.$emit('matricula-actualizada');
        this.close();
      } catch (e) {
        console.error('Error actualizando matrícula:', e);
      }
    },
  },
};
</script>
